module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/resetpassword/resetpassword.component.css
// module id = ./src/app/resetpassword/resetpassword.component.css
// module chunks = main